import { createAsyncThunk } from '@reduxjs/toolkit';
import { createRequest } from '../../../helpers/api/createRequest';
import * as documentsApi from '../../../api/docs';
import { AdditionalSettings } from '../../../types/Endpoints/documents/DocumentsContracts';

export const GET_ADDITIONAL_SETTINGS = 'additionalSettings/getAdditionalSettings';

export const getAdditionalSettings = createAsyncThunk<AdditionalSettings>(
    GET_ADDITIONAL_SETTINGS,
    createRequest({
        type: GET_ADDITIONAL_SETTINGS,
        loader: async () => documentsApi.getAdditionalSettings(),
    }),
);
